import { render } from "./ModalTiposModificacion.vue?vue&type=template&id=687cf64c"
import script from "./ModalTiposModificacion.vue?vue&type=script&lang=js"
export * from "./ModalTiposModificacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__